import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { FooterTrusted } from '../../../standard-shop-layout'
import {
  urlResolverGetAccountability,
  urlResolverGetAgb,
  urlResolverGetImprint,
  urlResolverGetPrivacySecurity,
} from '../../../url-handling'
import { getRegisterBoxConfigByTenant } from '../../registrationBoxConfig'
import { LoginRegistrationSiqtLogo } from '../LoginRegistrationSiqtLogo/LoginRegistrationSiqtLogo'

export const LoginRegistrationFooter: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()

  const { language, tenant } = useGlobalConfigContext()
  const registrationConfig = getRegisterBoxConfigByTenant(tenant)
  const trustLogos = registrationConfig?.logos[language]

  return (
    <div className="flex h-fit flex-col items-center justify-center bg-light-primary-low px-2 py-3">
      <div className="flex flex-col items-center justify-center tablet:flex-row">
        {trustLogos ? (
          <FooterTrusted className="tablet:hidden" trustedItems={trustLogos} />
        ) : null}
        <LoginRegistrationSiqtLogo className="mb-10 mt-6 tablet:hidden" />
      </div>

      <div className="flex flex-col items-center justify-center tablet:flex-row">
        <Link
          className="mb-2 ml-4 no-underline tablet:mb-0"
          href={urlResolverGetPrivacySecurity(globalConfig)}
        >
          {intl.formatMessage({ id: 'footer.links.label.privacyAndSecurity' })}
        </Link>
        <Link
          className="mb-2 ml-4 no-underline tablet:mb-0"
          href={urlResolverGetAgb(globalConfig)}
        >
          {intl.formatMessage({ id: 'footer.links.label.termsAndConditions' })}
        </Link>
        <Link
          className="mb-2 ml-4 no-underline tablet:mb-0"
          href={urlResolverGetAccountability(globalConfig)}
        >
          {intl.formatMessage({ id: 'footer.links.label.accountability' })}
        </Link>
        <Link
          className="mb-5 ml-4 no-underline tablet:mb-0"
          href={urlResolverGetImprint(globalConfig)}
        >
          {intl.formatMessage({ id: 'footer.links.label.imprint' })}
        </Link>
      </div>

      <span className="text-center text-xs">
        {intl.formatMessage({ id: 'footer.label.checkout.companyResidence' })}
      </span>
    </div>
  )
}
